export default function getSelectedDestinationsValues(selectedDestinations) {
  const mergeCountryDestinations = (accumulator, currentValue) =>
    (currentValue.allForCountry && accumulator.concat(currentValue.destinations)) ||
    (accumulator.push(currentValue) && accumulator);

  return selectedDestinations
    .reduce(mergeCountryDestinations, [])
    .map((destination) => destination.value || destination);
}
